import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { APP_VERSION } from './core/build-info';
import { LoggerService } from './core/logger/logger.service';

@Component({
  selector: 'rms-root',
  template: '<router-outlet />',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly logger = inject(LoggerService);

  // Surface the running version (npm version + CI build number) so a stale
  // embedded webview can be identified from its logs; matches the deploy tag.
  public ngOnInit(): void {
    this.logger.info(APP_VERSION, 'AppVersion');
  }
}
